import { render, staticRenderFns } from "./LinhaProdutoModalPromotor.vue?vue&type=template&id=3754f436&scoped=true"
import script from "./LinhaProdutoModalPromotor.vue?vue&type=script&lang=js"
export * from "./LinhaProdutoModalPromotor.vue?vue&type=script&lang=js"
import style0 from "./LinhaProdutoModalPromotor.vue?vue&type=style&index=0&id=3754f436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754f436",
  null
  
)

export default component.exports